import { WizardStep } from "../../ui/wizard"
import { NeutralButton } from "../../common/Buttons"
import AuditUnitDetails from "./AuditUnitDetails"
import { useState, useEffect } from "react"
import ImagePreview from "../../Dealer/NAP/ImagePreview"
import ImagePreviewGrid from "../../common/ImagePreviewGrid"
import InfoItem from "../../common/InfoItem"
import auditConditionEnum from "../../../constants/auditConditionEnum"
import { FaEdit } from "react-icons/fa"
import Spinner from "../../common/Spinner"
import { conditionColors } from "../../../utilities/auditUtilities"

export default function AuditUnitConfirm({
  auditUnit,
  auditData,
  onComplete,
  goToStep,
  setIsEditing
}) {
  const [imageUrls, setImageUrls] = useState({})
  const [previewImage, setPreviewImage] = useState(null)
  const [isCompleting, setIsCompleting] = useState(false)

  useEffect(() => {
    const urls = {}
    Object.entries(auditData.images).forEach(([key, file]) => {
      if (file) {
        urls[key] = URL.createObjectURL(file)
      }
    })
    setImageUrls(urls)
  }, [auditData.images])

  const handleEditClick = (index) => {
    setIsEditing(true)
    goToStep(index)
  }

  return (
    <WizardStep>
      <div className="flex flex-col items-center justify-between pt-6 rounded w-full h-full">
        <div className="flex flex-col w-full md:w-4/5">
          <AuditUnitDetails auditUnit={auditUnit} />
          <div className="mx-2 mt-2 border-t border-grey-700">
            <InfoItem title="Condition">
              <div className="flex items-center">
                <span className={conditionColors(auditData.condition)}>
                  {auditConditionEnum[auditData.condition]}
                </span>
                <FaEdit
                  className="ml-2 text-sm"
                  onClick={() => handleEditClick(0)}
                  data-testid="edit-condition-icon"
                />
              </div>
            </InfoItem>
            <InfoItem title="Can Refloor?">
              <div className="flex items-center">
                {auditData.can_refloor === '1' ? 'Yes' : 'No'}
              </div>
            </InfoItem>
            <InfoItem title="Sold?">
              <div className="flex items-center">
                {auditData.current_sold !== '2' ? 'Yes' : 'No'}
              </div>
            </InfoItem>
          </div>
        </div>

        <ImagePreviewGrid
          imageUrls={imageUrls}
          onClick={(key) => setPreviewImage(imageUrls[key])}
          onEditClick={(index) => handleEditClick(index + 1)}
          gridCols={Object.keys(imageUrls).length > 2 ? "grid-cols-3" : "grid-cols-2"}
        />

        <NeutralButton
          style="w-4/5"
          text={isCompleting ?
            <Spinner color="grey-300" height="20px" width="20px" strokeWidth={6} /> :
            "Complete Audit"
          }
          onClick={async () => {
            setIsCompleting(true)
            await onComplete()
            setIsCompleting(false)
          }}
        />
      </div>

      <div className="fixed top-0 left-0 z-50">
        {previewImage && <ImagePreview
          image={previewImage}
          onClose={() => setPreviewImage(null)}
        />}
      </div>
    </WizardStep>
  )
}